module.exports = __webpack_public_path__ + "img/logo.823ad81a.svg";